module.exports = __webpack_public_path__ + "img/AneuFlow_Series.814b1698.png";